// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"b6366e1a","450":"b6366e1a"}[chunkId] + ".chunk.css";
};